import React, { useState, useRef, useEffect, useContext } from "react";
import "./style.scss";
import StaffDashboardLeftContent from "./leftContainer";
import TabComponent from "./Tab-Component";
import ClinicWrapper from "../ClinicWrapper";
import MyProfileContent from "./MyProfileContent";
import DoctorContext from "../ClinicWrapper/DoctorContext";
import NextAppointmentWidget from "./next-appointment-widget";
import { APPLICABLE_ROLE } from "../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../Util/constants";

const DoctorAdminDashboard = (props) => {
  const scrollRef = useRef(null);
  const [showJoyride, setShowJoyride] = useState(false);
  const [showTab, setShowTab] = useState();
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctor_context = useContext(DoctorContext);
  const user_type = localStorage.getItem("user_type");
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [renderNextAppointmentApi, setRenderNextAppointmentApi] =
    useState(false);
  const [callLastConsultationFeedback, setCallLastConsultationFeedback] =
    useState(false);
  const [clinicDropDownStatus, setClinicDropdownStatus] = useState(false);

  useEffect(() => {
    if (
      (doctor_context.clinic_id !== undefined &&
        doctor_context.clinic_id !== null &&
        doctor_context.clinic_id !== "" &&
        doctorRole !== undefined &&
        doctorRole !== null &&
        doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
        doctorRole !== USER_ROLE.RESOURCE_CONSULTANT) ||
      user_type == "staff"
    ) {
      setShowTab(true);
    } else {
      setShowTab(false);
    }
  }, [doctor_context.clinic_id, doctor_context.doctorRole]);
  const joyrideToggle = () => setShowJoyride(!showJoyride);
  // Callback to get next appointment
  function getNextAppointment(next) {
    setRenderNextAppointmentApi(false);
  }

  const callNextAppointmentWidget = () => {
    setRenderNextAppointmentApi(true);
  };

  const handleEndCall = () => {
    setCallLastConsultationFeedback(true);
  };

  return (
    <>
      <div className="container-fluid p-0" style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            borderBottom: "1px solid #d6dae5",
            borderTop: "1px solid #d6dae5",
            display: "flex",
            boxShadow: "0 2px 5px 2px rgb(0, 0, 0, 0.1)",
          }}
        >
          <ClinicWrapper
            isPageHeading={false}
            joyrideToggle={joyrideToggle}
            headerText={localStorage.getItem("full_name")}
            homeClick={() => {
              props.history.push("/");
            }}
            setClinicMenu={(status) => {
              setClinicDropdownStatus(status);
            }}
          />
        </div>

        {/* <PageHeading text={"DASHBOARD"} /> */}
        <div className="row dashboard-container m-0">
          <div className="col-lg-9 col-12 p-0 dashboard-left-container">
            <StaffDashboardLeftContent
              handleRatingPopup={() => {
                setShowRatingPopup(true);
              }}
              callNextAppointmentWidget={callNextAppointmentWidget}
              handleEndCall={handleEndCall}
              clinicDropDownStatus={clinicDropDownStatus}
            />
          </div>
          <div
            ref={scrollRef}
            className={
              "col-lg-3 col-12 p-0 dashboard-right-container " +
              (window.innerWidth < 767 ? "pb-5" : "")
            }
          >
            {user_type === APPLICABLE_ROLE.DOCTOR &&
              doctorRole !== USER_ROLE.RESOURCE_ADMIN &&
              doctorRole !== USER_ROLE.RESOURCE_CONSULTANT &&
              window.innerWidth > 798 && (
                <div className="col-sm-12 col-lg-12 col-12 pb-4 mt-4 doctor_card_view w-100">
                  <NextAppointmentWidget
                    clinicId={clinicId}
                    handleRatingPopup={() => {
                      setShowRatingPopup(true);
                    }}
                    renderNextAppointmentApi={renderNextAppointmentApi}
                    getNextAppointmentCallback={getNextAppointment}
                    handleEndCall={handleEndCall}
                  />
                </div>
              )}
            {showTab ? (
              <TabComponent
                showRatingPopup={showRatingPopup}
                callLastConsultationFeedback={callLastConsultationFeedback}
                setCallLastConsultationFeedback={
                  setCallLastConsultationFeedback
                }
                scrollRef={scrollRef}
                callNextAppointmentWidget={callNextAppointmentWidget}
              />
            ) : (
              <MyProfileContent
                showRatingPopup={showRatingPopup}
                callLastConsultationFeedback={callLastConsultationFeedback}
                setCallLastConsultationFeedback={
                  setCallLastConsultationFeedback
                }
                callNextAppointmentWidget={callNextAppointmentWidget}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorAdminDashboard;
